import type { DealPayableOverageHint } from "@/lib/ops/manufacturerPayablesMath";

function money(n: number): string {
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function OpsManufacturerPayableOverageHints(props: {
  hints: DealPayableOverageHint[];
  onFill: (hint: DealPayableOverageHint) => void;
}) {
  if (props.hints.length === 0) return null;
  return (
    <div className="rounded-xl border border-indigo-200 bg-indigo-50 px-3 py-2 text-sm dark:border-indigo-800 dark:bg-indigo-950/40">
      <div className="text-xs font-semibold uppercase tracking-wide text-indigo-900 dark:text-indigo-100">
        Collected over dealer deposit
      </div>
      <p className="mt-1 text-[11px] text-indigo-800 dark:text-indigo-200">
        Fill the form, type the manufacturer, then add to the AP scroll. Manufacturer names stay
        org-typed.
      </p>
      <ul className="mt-2 max-h-40 space-y-1 overflow-y-auto">
        {props.hints.map((h) => (
          <li key={h.deal_id} className="flex flex-wrap items-center justify-between gap-2">
            <span className="min-w-0 truncate text-indigo-950 dark:text-indigo-50">
              {h.display_name} · collected {money(h.collected_usd)} − deposit {money(h.allowed_deposit_usd)}{" "}
              = {money(h.amount_owed_usd)} owed
            </span>
            <button
              type="button"
              className="shrink-0 rounded-full bg-indigo-600 px-2 py-0.5 text-xs text-white"
              onClick={() => props.onFill(h)}
            >
              Fill form
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
